import { PLAYER_GRADIENTS } from './mockCardPool';

export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export function gradientForIndex(index: number): string {
  return PLAYER_GRADIENTS[index % PLAYER_GRADIENTS.length]!;
}
